<div mat-dialog-content class="popup-content">
    <h2 class="popup-title">{{data.title}}</h2>
    <p class="popup-message">{{data.msg}}</p>
</div>
<div mat-dialog-actions class="popup-actions">
    <button mat-raised-button class="acept_button" (click)="confirmarEliminacion()">Aceptar</button>
    <button mat-raised-button class="cancel_button" (click)="cancelarEliminacion()">Cancelar</button>
</div>